

export interface IFormField {

    key: string;               // key - currently how it is presented in mapping table
    name: string;              // name - ILS POST
    path?: string;             // path - ILS GET
    existingPath?: string;     // existingPath - check if this field should be displayed and any metadata like len on this field
    label: string;             // label - translate label
    value: string;             // TODO - can be deleted
    duplicateOf? : string;     // duplicateOf - name of field which already presents this item 
                               //               (exists both in Aleph and Voyager by different name, path)
    dependOn? : IDependOn;     // dependOn - key: name of field
                               //            value: field's value  
    mandatory?:boolean;        // mandatory - required
    fieldType: string;         // fieldType - logic type, i.e. string, number 
    uiType: string;            // uiType   - i.e. free text, dropdown
    options?: common.IOption;  // options - i.e. in case of dropdown, radio
  
    
    saveFormField : IFormField;

    populator?:  {
        func: (form:Object, formData:Object, data:Object) => void;
        params: {
            allow?: string;
            key?: string;
            value?: string;
            filters?: string[];
            defaultValue?: string;
            singleValueBehaviour?: string;
        }
    };
    events?: {
        onChange?: Function;
        params : string[];
    };
    style?: IStyle;
}

export function YesOrNo() {
    return [
        {
            label: 'illrequest.label.Y',
            value: 'Y'
        },
        {
            label: 'illrequest.label.N',
            value: 'N'
        }
    ];
}

export interface IStyle {
    layout:    string;
}

export interface IDependOn {
    key: string;
    isExists: boolean; 
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/formBuilder/field/formField.interface.ts